import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Cuboid = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M16.707 2.293A.996.996 0 0016 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 00.227 1.066l5 5A.996.996 0 008 22h8c.414 0 .785-.255.934-.641l5-13a.999.999 0 00-.227-1.066l-5-5zM18.585 7h-5.171l-3-3h5.172l2.999 3zM8.381 4.795l3.438 3.438-4.462 10.71-3.19-3.191L8.381 4.795zM15.313 20h-6.23l4.583-11h5.878l-4.231 11z",
    key: "k0"
  }));
});
Cuboid.displayName = 'Cuboid';
export var CuboidDimensions = {
  height: 24,
  width: 24
};